import { IssueBanner } from '@/components/Chat/IssueBanner'
import { blockingChecks, checkLine, CheckSeverity, type FillCheck } from '@/models/fillApplication'
import { useFillJump } from './FillJumpProvider'

export function CardChecks({ checks }: { checks: FillCheck[] }) {
  const { jump } = useFillJump()
  const blocking = blockingChecks(checks)
  const warnings = checks.filter((check) => check.severity === CheckSeverity.WARNING)

  return (
    <>
      <IssueBanner
        variant="error"
        lines={blocking.map(checkLine)}
        onLineClick={(index) => jump(blocking[index])}
      />
      <IssueBanner
        variant="warning"
        lines={warnings.map(checkLine)}
        onLineClick={(index) => jump(warnings[index])}
      />
    </>
  )
}
